/* G Decor — Load More pagination for collection pages */
(function(){
  var loadmoreWrap = document.querySelector('[data-gd-loadmore]');
  if(!loadmoreWrap) return;

  var grid = document.querySelector('[data-gd-loadmore-grid]');
  var btn = loadmoreWrap.querySelector('[data-gd-loadmore-btn]');
  var shownEl = loadmoreWrap.querySelector('[data-shown]');
  var totalEl = loadmoreWrap.querySelector('[data-total]');
  var backToTop = document.querySelector('[data-gd-back-to-top]');
  var btnOriginalText = btn ? btn.textContent : 'Load More Products';

  if(!grid) return;

  // Back to top — show after enough scroll
  if(backToTop){
    var scrollHandler = function(){
      if(window.scrollY > window.innerHeight * 1.5){
        backToTop.classList.add('is-visible');
      } else {
        backToTop.classList.remove('is-visible');
      }
    };
    window.addEventListener('scroll', scrollHandler, {passive: true});
    backToTop.addEventListener('click', function(e){
      e.preventDefault();
      window.scrollTo({top: 0, behavior: 'smooth'});
    });
  }

  if(!btn) return;

  btn.addEventListener('click', function(e){
    e.preventDefault();
    if(btn.classList.contains('is-loading')) return;
    var nextUrl = btn.getAttribute('data-next-url');
    if(!nextUrl) return;

    btn.classList.add('is-loading');
    btn.textContent = 'Loading…';

    fetch(nextUrl, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r){ return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function(html){
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-gd-loadmore-grid]');
        var newBtn = doc.querySelector('[data-gd-loadmore-btn]');
        var newWrap = doc.querySelector('[data-gd-loadmore]');

        if(newGrid){
          var newProducts = newGrid.querySelectorAll('.gd-product');
          newProducts.forEach(function(p){
            // append with fade-in
            p.style.opacity = '0';
            p.style.transition = 'opacity .4s ease';
            grid.appendChild(p);
            requestAnimationFrame(function(){
              setTimeout(function(){ p.style.opacity = '1'; }, 30);
            });
          });
        }

        // Update shown count
        if(newWrap && shownEl){
          var newShown = newWrap.getAttribute('data-shown');
          if(newShown){
            shownEl.textContent = newShown;
            loadmoreWrap.setAttribute('data-shown', newShown);
          }
        }

        // Update button next URL or remove
        if(newBtn){
          var nextNextUrl = newBtn.getAttribute('data-next-url');
          if(nextNextUrl){
            btn.setAttribute('data-next-url', nextNextUrl);
            btn.setAttribute('href', nextNextUrl);
            btn.classList.remove('is-loading');
            btn.textContent = btnOriginalText;
          } else {
            btn.parentNode.removeChild(btn);
          }
        } else {
          btn.parentNode.removeChild(btn);
        }
      })
      .catch(function(err){
        console.error('Load more error:', err);
        btn.classList.remove('is-loading');
        btn.textContent = btnOriginalText;
      });
  });
})();
